/**
 * Announcements from the team (TMMAPP-0142 U2 item 13a): one `GET /v1/me/announcements` per shell
 * mount, read by the account menu's "What's new" (its badge and dialog), Help & feedback's
 * Announcements tab, and the one-time pop-up. Opening one marks it read for all of them.
 */
import { createContext, useContext } from 'react';
import type { Announcement } from '@/api/announcements';

export interface AnnouncementsValue {
  /** null until the first read answers (or when it failed). */
  items: Announcement[] | null;
  unreadCount: number;
  error: unknown;
  reload: () => void;
  /** Marks one read (idempotent): the badges drop at once, then `POST …/{id}/read`. */
  markRead: (id: number) => void;
  /** Opens "What's new" (the list in a dialog), from the account menu. */
  openWhatsNew: () => void;
}

export const AnnouncementsContext = createContext<AnnouncementsValue | null>(null);

/** `null` outside the shell (a page rendered on its own in a test). */
export function useAnnouncements(): AnnouncementsValue | null {
  return useContext(AnnouncementsContext);
}
